<template>
  <div id="scrollDiv" style="min-height: 1000px" v-loading="loading" element-loading-text="提交中....">
    <div class="titleStyle">
      <p> {{ paperTitle }} </p>
    </div>

    <div v-for="(item,index) in allQuestionArr" :key="index">
      <div class="titleType">
        <p>
          {{ item.name }}
        </p>
      </div>
      <div style="padding-bottom: 10px;" v-for="(item1,index1) in item.questionItems"
           :key="index1">
        <a :id="'q' + item1.itemOrder">
          <radioSubject v-if="(item1.questionType === 0) || (item1.questionType === 1) "
                        :subjectId="item1.itemOrder" @changed="changed" @unchanged="unchanged"
                        :questionBody="item1">
          </radioSubject>
          <checkSubject v-if="item1.questionType === 2" :subjectId="item1.itemOrder" @changed="changed"
                        @unchanged="unchanged" :questionBody="item1"></checkSubject>
          <shortAnswerSubject v-if="item1.questionType === 3" :subjectId="item1.itemOrder" @changed="changed"
                              @unchanged="unchanged" :questionBody="item1">
          </shortAnswerSubject>
          <programmingSubject v-if="item1.questionType === 4" :subjectId="item1.itemOrder" @changed="changed"
                              @unchanged="unchanged" :questionBody="item1">
          </programmingSubject>
          <blankSubject v-if="item1.questionType === 5" :subjectId="item1.itemOrder"
                        @changed="changed"
                        @unchanged="unchanged" :questionBody="item1">
          </blankSubject>
        </a>
      </div>
      <!--            <el-divider></el-divider>-->
    </div>

    <div class="submit-btn">
      <el-button type="primary" icon="el-icon-check" @click="submitPaper">提交试卷</el-button>
    </div>

    <answer v-if="showAnswer" is-show="showAnswer" :scoreDetail="answerInfo"></answer>
  </div>
</template>

<script>
import {eventBus} from '@/main.js'
import radioSubject from "@/components/radioSubject.vue"
import checkSubject from "@/components/checkSubject.vue"
import blankSubject from "@/components/blankSubject.vue"
import shortAnswerSubject from "@/components/shortAnswerSubject.vue"
import programmingSubject from "@/components/programmingSubject.vue"
import programmingSubjectMore from "@/components/programmingSubjectMore.vue"
import answer from "@/components/answer.vue";
import {
  submitPaperAnswer
} from "@/api/index.js"


export default {
  props: {
    allQuestionArr: {
      type: Array,
      default: () => [{}]
    },
    paperTitle: {
      type: String,
      default: '试卷标题'
    },
    //用于快速定位的题目位置
    maodian: {
      type: String,
      default: '#1'
    },
  },
  //禁止复制
  created() {
    this.$nextTick(() => {
      // 禁用右键
      document.oncontextmenu = new Function("event.returnValue=false");
      // 禁用选择
      document.onselectstart = new Function("event.returnValue=false");
    });
  },
  watch: {
    allQuestionArr: {
      handler: function (n, o) {
        this.allQuestionArr.forEach((item) => {
          item.questionItems.forEach((item1) => {
            if (item1.questionType == 5) {
              let tmpEnter = [];
              for (let i = 0; i < item1.enterNum; i++) {
                // Things[i]
                let tmp = {
                  id: i + 1,
                  value: ""
                }
                tmpEnter.push(tmp)
              }
              item1.tmpEnter = tmpEnter
            }
          })
        })
      }
    },
    isAnswer: {
      handler: function (n, o) {
        // console.log(this.isAnswer);
        if (this.isAnswer.length != 0) {
          this.$emit("isAnswerArr", this.isAnswer)
        }
      }
    },
    maodian: {
      handler: function (n, o) {
        var target = document.querySelector(this.maodian);
        this.scrollAnimation(document.getElementById("scrollDiv").parentNode.scrollTop, (target.offsetTop -
            40))
      },
      deep: true
    }
  },
  components: {
    radioSubject,
    checkSubject,
    blankSubject,
    shortAnswerSubject,
    programmingSubject,
    programmingSubjectMore,
    answer
  },
  data() {
    return {
      isAnswer: [],
      loading: false,
      showAnswer: false,
      answerInfo: {}
    }
  },
  methods: {
    submitPaper() {
      eventBus.$emit('message-submit-paper', 'submit-paper');
    },

    scrollAnimation(currentY, targetY) {
      // 计算需要移动的距离
      let needScrollTop = targetY - currentY - 22
      let _currentY = currentY
      setTimeout(() => {
        // 一次调用滑动帧数，每次调用会不一样
        const dist = Math.ceil(needScrollTop / 10)
        _currentY += dist
        // document.getElementById("scrollDiv").parentNode.scrollTo(_currentY, currentY);
        window.scrollTo(_currentY, currentY);
        // 如果移动幅度小于十个像素，直接移动，否则递归调用，实现动画效果
        if (needScrollTop > 10 || needScrollTop < -10) {
          this.scrollAnimation(_currentY, targetY)
        } else {
          window.scrollTo(0, _currentY);
          // document.getElementById("scrollDiv").parentNode.parentNode.parentNode.scrollTo(0, _currentY)
        }
      }, 1)
    },
    changed(item) {
      if (this.isAnswer.length === 0) {
        this.isAnswer.push(item)
      } else {
        let flag = 0
        this.isAnswer.forEach((item1) => {
          if (item1.id === item.id) {
            flag = 1
            item1.content = item.content
            item1.contentArray = item.contentArray
            item1.userAnswerFileId = item.userAnswerFileId
          } else {
          }
        })
        if (flag === 0) {
          this.isAnswer.push(item)
        }
      }
    },
    unchanged(item) {
      this.isAnswer.filter((item1, index) => {
        if (item1.id === item.id) {
          this.isAnswer.splice(index, 1)
        }
      })
    },
    submitSubject(id, studentWorkInfoId, time) {
      // 检查是否有正在上传的文件
      const programmingSubjects = this.$children.filter(child =>
          child.$options && child.$options._componentTag === 'programmingSubject'
      );

      // 检查是否有任何编程题组件正在进行文件上传
      // 只检查那些需要上传文件的编程题（即langCode为Scratch的题目）
      const uploadingFiles = programmingSubjects.some(subject => {
        // 检查是否正在上传文件，并且该题目需要上传文件
        return subject.questionBody &&
            subject.questionBody.langCode === 'Scratch' &&
            subject.isUploading;
      });

      if (uploadingFiles) {
        this.$message({
          type: 'warning',
          message: '还有文件正在上传中，请等待上传完成后再提交试卷！'
        });
        return;
      }

      this.$confirm('是否确定提交试卷？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doSubmitPaper(id, studentWorkInfoId, time);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消提交'
        });
      });
    },
    // 强制提交试卷（考试时间到时自动调用，无需确认）
    forceSubmitSubject(id, studentWorkInfoId, time) {
      this.doSubmitPaper(id, studentWorkInfoId, time);
    },
    // 实际提交试卷的方法
    doSubmitPaper(id, studentWorkInfoId, time) {
      this.loading = true;
      
      // 获取所有题目的答案，未作答的题目默认为"未作答"
      let allAnswerItems = this.getAllAnswerItems();
      
      let param = {
        id: id,
        studentWorkInfoId: studentWorkInfoId,
        doTime: Number(time),
        answerItems: allAnswerItems
      }
      submitPaperAnswer(param).then(res => {
        this.loading = false;
        if (res.code === "0000") {
          this.answerInfo = res.data
          this.showAnswer = true
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    // 获取所有题目的答案，未作答的题目设置默认值
    getAllAnswerItems() {
      let allAnswers = [...this.isAnswer]; // 复制已作答的题目
      let answeredIds = this.isAnswer.map(item => item.id); // 已作答的题目ID列表
      
      // 遍历所有题目，为未作答的题目添加默认答案
      this.allQuestionArr.forEach(section => {
        if (section.questionItems) {
          section.questionItems.forEach(question => {
            if (!answeredIds.includes(question.itemOrder)) {
              allAnswers.push({
                id: question.itemOrder,
                questionId: question.id,
                content: '未作答',
                contentArray: [],
                itemOrder: question.itemOrder
              });
            }
          });
        }
      });
      
      return allAnswers;
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__header {
  background-color: #FFFFFF;
  border: none;
}

a {
  text-decoration: none !important;
}

.titleStyle {
  width: 100%;
  padding: 20px 0 28px;
  margin-bottom: 28px;
  text-align: center;

  p {
    font-size: 24px;
    font-weight: 600;
    line-height: 1.4;
    color: #1a1a2e;
    letter-spacing: 1px;
    margin: 0;
  }
}

.titleType {
  width: 100%;
  height: 44px;
  background-color: #f5f7fa;
  border-radius: 8px;
  margin-bottom: 16px;
  padding: 0 24px;
  box-sizing: border-box;

  p {
    font-size: 17px;
    font-weight: 600;
    line-height: 44px;
    color: #303133;
    margin: 0;
  }
}

::v-deep .el-card {
  border: none;
  box-shadow: none;
  border-bottom: 1px solid #ebeef5;
  border-radius: 0;
}

::v-deep .el-card.is-always-shadow,
.el-card.is-hover-shadow:focus,
.el-card.is-hover-shadow:hover {
  box-shadow: none;
}

.submit-btn {
  display: flex;
  justify-content: center;
  padding: 40px 0 20px;
  margin-top: 20px;

  ::v-deep .el-button {
    padding: 14px 56px;
    font-size: 16px;
    font-weight: 500;
    border-radius: 8px;
    background: #409EFF;
    border: none;
    transition: all 0.25s ease;
    letter-spacing: 2px;

    &:hover {
      background: #66b1ff;
    }
  }
}
</style>
